export const readableGender = {
  MALE: 'männlich',
  FEMALE: 'weiblich',
  DIVERS: 'divers'
}
